<script>
	import { Link } from 'svelte-routing';
	let expandedFaq = null;

	const faqs = [
		{
			question: 'Vad är Boanalys och hur hjälper tjänsten mig?',
			answer:
				'<p>Boanalys är en AI-baserad plattform som analyserar bostadsrättsföreningars årsredovisningar, stadgar och energideklarationer. Vi omvandlar komplex information till en lättförståelig rapport och en interaktiv översikt över föreningens ekonomi, underhållsbehov och potential. Detta hjälper dig att fatta tryggare och mer välgrundade bostadsbeslut.</p>'
		},
		{
			question: 'Vem kan använda tjänsten?',
			answer:
				'<p>Tjänsten är utvecklad för alla som är engagerade i bostadsrättsmarknaden. Den ger ett stort stöd till bostadsköpare, men är även värdefull för säljare, boende, styrelsemedlemmar, mäklare och banktjänstemän som vill få en tydligare och mer nyanserad bild av en bostadsrättsförenings status.</p><p>För verksamheter som vill arbeta mer datadrivet erbjuder vi dessutom möjligheten att antingen extrahera data direkt eller ansluta via våra API:er. På så sätt kan informationen integreras i befintliga system, användas för egna analyser eller ligga till grund för automatiserade arbetsflöden.</p><p>För mer information kan ni kontakta oss på info@boanalys.io</p>'
		},
		{
			question: 'Är Boanalys gratis?',
			answer:
				'<p>Ja, kärnan i vår tjänst är helt gratis att använda. Vi anser att tillgång till pålitlig information är en rättighet. För tillgång till mer avancerade funktioner kan ni kontakta oss på info@boanalys.io</p>'
		},
		{
			question: 'Hur får jag tillgång till en analys?',
			answer:
				'<p>Sök helt enkelt på föreningens namn eller adress i sökfältet. Vi har redan analyserat över 10 000 föreningar. Är din förening inte analyserad kan du enkelt skapa ett gratiskonto och ladda upp årsredovisningen själv. Analysen är klar på bara några sekunder.</p>'
		},
		{
			question: 'Var kommer er data ifrån?',
			answer:
				'<p>Vi använder en avancerad process för att säkerställa hög datakvalitet som slår befintliga lösningar på marknaden som både är manuella och bygger på AI. Informationen extraheras från årsredovisningar, stadgar och energideklarationer och tolkas av en specialanpassad språkmodell. Vi validerar och korsrefererar sedan datan mot andra källor och använder matematiska kontroller för att garantera korrektheten.</p>'
		},
		{
			question: 'Hur hanterar ni mina personuppgifter?',
			answer:
				'<p>Vi behandlar dina personuppgifter strikt i enlighet med dataskyddsförordningen (GDPR). Din information används endast för att tillhandahålla och förbättra vår tjänst. Vi delar aldrig dina uppgifter med tredje part utan ditt uttryckliga samtycke. Du kan läsa mer i våra <a href="/legal" style="color: var(--hover);">allmänna villkor</a>.</p>'
		},
		{
			question: 'När började Boanalys utvecklas?',
			answer:
				'<p>Boanalys började ta form under början av 2024 när behovet av mer tillförlitlig analys av bostadsrättsföreningar blev tydligt.</p>'
		}
	];

	function toggleFaq(index) {
		expandedFaq = expandedFaq === index ? null : index;
	}
</script>

<section class="faq-section">
	<h2>Vanliga frågor</h2>
	<p class="faq-subtitle">Här hittar du svar på de vanligaste frågorna om Boanalys.</p>

	<div class="faq-container">
		{#each faqs as faq, i}
			<div class="faq-item">
				<button class="faq-toggle" on:click={() => toggleFaq(i)}>
					<span class="faq-title">{faq.question}</span>
					<span class="faq-icon" class:expanded={expandedFaq === i}>+</span>
				</button>
				{#if expandedFaq === i}
					<div class="faq-content">
						{@html faq.answer}
					</div>
				{/if}
			</div>
		{/each}
	</div>
</section>

<style>
	.faq-section {
		padding: 80px 20px;
		max-width: 800px;
		margin: 0 auto;
		text-align: center;
	}

	.faq-section h2 {
		font-size: 2.5rem;
		margin-bottom: 20px;
		color: #333;
	}

	.faq-subtitle {
		font-size: 1.1rem;
		color: #555;
		margin-bottom: 40px;
		line-height: 1.6;
	}

	.faq-container {
		max-width: 600px;
		margin: 0 auto;
	}

	.faq-item {
		border-bottom: 1px solid #e0e0e0;
		margin-bottom: 0;
	}

	.faq-item:last-child {
		border-bottom: none;
	}

	.faq-toggle {
		width: 100%;
		background: none;
		border: none;
		padding: 20px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
		font-size: 1.1rem;
		font-weight: 500;
		color: #333;
		text-align: left;
		transition: all 0.2s ease;
	}

	.faq-toggle:hover {
		color: var(--hover);
	}

	.faq-title {
		flex: 1;
	}

	.faq-icon {
		font-size: 1.5rem;
		font-weight: 300;
		color: var(--hover);
		transition: transform 0.2s ease;
		width: 20px;
		text-align: center;
	}

	.faq-icon.expanded {
		transform: rotate(45deg);
	}

	.faq-content {
		padding: 0 0 20px 0;
		text-align: left;
		animation: fadeIn 0.3s ease;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@media (max-width: 768px) {
		.faq-section {
			padding: 60px 20px;
		}
		.faq-section h2 {
			font-size: 2rem;
		}
		.faq-toggle {
			font-size: 1rem;
			padding: 15px 0;
		}
	}
</style>
